export function isAssistant(subId=localStorage.getItem('currentSubAccountId') ) {
    try {
        const userProfile = JSON.parse(localStorage.getItem('eahsUserProfile')) ?? '';

        const selectedAccount = userProfile?.subAccounts?.find(item => item.value == subId) ?? {};

        if (selectedAccount?.isAssistant == true) {
            return true;
        }
        else {
            return false;
        }
    } catch (error) {
        return false;
    }
}